import { useState } from 'react';

import { RecurringSubscriptionAmountCalculationResponse } from 'chaika-frontend-types/frontend-cms';

import { RecurringSubscriptionApi } from '@api/RecurringSubscriptionApi';

import { useDataLoading } from '@utils/hooks/useDataLoading';
import { isDefined } from '@utils/isDefined';

interface Params {
    doctorId?: string;
}

interface UseSubscriptionBillingAmount {
    billingAmount?: RecurringSubscriptionAmountCalculationResponse;
    isBillingAmountLoading: boolean;
}

export const useSubscriptionBillingAmount = ({ doctorId }: Params): UseSubscriptionBillingAmount => {
    const [billingAmount, setBillingAmount] = useState<RecurringSubscriptionAmountCalculationResponse>();
    const [isBillingAmountLoading, setIsBillingAmountLoading] = useState(isDefined(doctorId));

    useDataLoading(async () => {
        if (isDefined(doctorId)) {
            setIsBillingAmountLoading(true);
            try {
                const billingAmount = await RecurringSubscriptionApi.calculateBillingAmount({
                    doctorId,
                });
                setBillingAmount(billingAmount);
            } catch {
            } finally {
                setIsBillingAmountLoading(false);
            }
        } else {
            setBillingAmount(undefined);
            setIsBillingAmountLoading(false);
        }
    }, [doctorId]);

    return {
        billingAmount,
        isBillingAmountLoading,
    };
};
